<template>
  <div>
    <label>Email Details</label>
    <history-details-key-value-list :values="keyValuePairs" class="mx-3" />

    <div class="pr-2" v-if="bag.attachments && bag.attachments.length > 0">
      <label>Attachments:</label>
      <ol>
        <li v-for="attachment in bag.attachments" :key="attachment.attachmentId">
          <a  @click="downloadEmailAttachment(attachment.emailMessageAttachmentId)" role="button" size="xs">
            {{ attachment.fileName }}
            <i class="ml-1 fa fa-download"/>
          </a>
        </li>
      </ol>
    </div>

    <div v-if="mailParams">
      <label>Message Parameters:</label>
      <history-details-key-value-list :values="mailParams" class="mx-3" />
    </div>
  </div>
</template>


<script>
import {romeApi} from "../../framework/utils/rome-api";
import {amfx} from "../../framework/utils/amfx";
import AmfButton from "../../framework/primitives/AmfButton.vue";
import HistoryDetailsKeyValueList from "./HistoryDetailsKeyValueList.vue";


export default {
  components: {HistoryDetailsKeyValueList, AmfButton},
  data() {
    return {

    }
  },
  props: {
    bag: { type: Object, required: true }
  },
  computed: {
    ...amfx.map("route", "participantId"),
    mailParams(){
      if (!this.bag.mailParams) return;

      return Object.entries( this.bag.mailParams).filter(x => x[0] != 'postmarkRequires').map(([key, value]) => {
        return { key, value };
      });
    },
    keyValuePairs() {
      const kvps = [];

      kvps.push({ key: "To", value: this.bag.to });
      if (this.bag.replyTo) kvps.push({ key: "Reply To", value: this.bag.replyTo });
      if (this.bag.cc) kvps.push({ key: "CC", value: this.bag.cc });
      if (this.bag.bcc) kvps.push({ key: "BCC", value: this.bag.bcc });
      kvps.push({ key: "Subject", value: this.bag.subject });
      if (this.bag.isDownloadable) kvps.push({ key: "Body", value: "Download", clickAction: () => this.downloadEmail(), icon: "fa-download" });

      return kvps;
    }
  },
  methods: {
    async downloadEmail() {
      await romeApi.download(`/participant/${this.participantId}/email/download/${this.bag.emailMessageId}`);
    },
    async downloadEmailAttachment(attachmentId) {
      await romeApi.download(`/participant/${this.participantId}/email/download/attachment/${attachmentId}`);
    },
  },
}

</script>


<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/history/modals/EmailDetails.vue